<template>
  <list-input-text
    type="text"
    placeholder="読書"
    :get="get"
    :set="set"
  />
</template>

<script>
import ListInputText from '@/lib/List/Input/Text'

export default {
  components: {
    ListInputText
  },

  computed: {
    get () {
      return () => {
        return this.$store.state.habit.name
      }
    },

    set () {
      return (value) => {
        this.$store.commit('habit/setName', value)
      }
    }
  }
}
</script>
